import { v4 as uuidv4 } from 'uuid';
import { computed, ref } from '@vue/composition-api';
import { PublisherType } from '@/enums';

const chatUserId = ref(null);
const userItem = 'chatUserId';
const userType = ref(null);

export default function useUser() {
  function storeUserId(payload) {
    window.localStorage.setItem(userItem, payload);
  }

  function createUserId() {
    const newId = uuidv4();
    storeUserId(newId);
  }

  function fetchUserType() {
    userType.value = PublisherType.CANDIDATE;
  }

  function initUser() {
    chatUserId.value = window.localStorage.getItem(userItem) || createUserId();
    fetchUserType();
  }

  return {
    initUser,
    userType: computed(() => userType.value),
    chatUserId: computed(() => chatUserId.value),
  };
}
